import { Action } from "@ngrx/store";

export interface CustomAction extends Action {
  payload?: any;
}

export const CLEAR_ALL_STORES_STATE = "CLEAR_ALL_STORES_STATE";
